import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navbar({ title, breadcrumb }) {
  const navigate = useNavigate();
  const workerFirstName = localStorage.getItem('workerFirstName') || '';
  const workerLastName = localStorage.getItem('workerLastName') || '';

  function logout() {
    localStorage.clear();
    navigate('/login');
  }

  return (
    <div className="navbar">
      <div className="navbar-brand" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <img
          src="https://aura-tenant-portal-files.s3.us-east-1.amazonaws.com/branding/community-logo.png"
          alt="Community"
          style={{ height: 40, width: 'auto', objectFit: 'contain' }}
        />
        <div>
          <h1 style={{ margin: 0 }}>{title || 'ניהול קהילה'}</h1>
          {breadcrumb && <div className="breadcrumb">{breadcrumb}</div>}
          {workerFirstName && (
            <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.8)', marginTop: 2 }}>
              שלום, {workerFirstName} {workerLastName}
            </div>
          )}
        </div>
      </div>
      <div className="navbar-user">
        <button onClick={logout}>התנתק</button>
      </div>
    </div>
  );
}
